var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrap d-flex justify-content-center align-items-center"},[_c('div',[_vm._m(0),_c('div',{staticClass:"empty-description"},[_vm._v(_vm._s(_vm.$t('common.permission.403')))])])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"empty-image"},[_c('img',{attrs:{"src":require("../../../assets/images/empty.svg")}})])
}]

export { render, staticRenderFns }